import React, { FC, useEffect, useState } from 'react';
import { useExtensionObserver } from '../../../scripts/hooks/extension';
import {
  extensionEnabledBrowser,
  installExtension,
  isChrome,
} from '../../../scripts/utils';
import { Card, CardContent } from '../../shadcn/lib/components/card';
import { UIButton } from '../ui/UIButton/UIButton';
import { UIIcon } from '../ui/UIIcon/UIIcon';

export const InstallExtensionCard: FC = () => {
  const [show, setShow] = useState(false);

  const extensionInstalled = useExtensionObserver();

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 200);
  }, []);

  if (!show || !extensionEnabledBrowser || extensionInstalled) {
    return null;
  }

  return (
    <div className="m-2 animate-in fade-in ease-in-out duration-500">
      {window.innerHeight > 780 ? (
        <Card className="bg-amethys-20">
          <CardContent className="flex flex-col gap-1">
            <UIIcon
              name={isChrome ? 'chrome' : 'firefox'}
              size={24}
              type="apps"
            />
            <div className="text-white font-medium">
              Install Extension for a better experience
            </div>
            <div className="text-sm text-gray-30">
              This is required in order to connect some apps and give you
              accurate answers.
            </div>
            <UIButton
              className="w-full mt-3"
              onClick={installExtension}
              type="secondary"
            >
              Install Extension
            </UIButton>
          </CardContent>
        </Card>
      ) : (
        <UIButton
          className="!px-3 flex !justify-start gap-1.5 w-full"
          onClick={installExtension}
        >
          <UIIcon
            className="preserveFill"
            name={isChrome ? 'chrome' : 'firefox'}
            type="apps"
          />
          Install Extension
        </UIButton>
      )}
    </div>
  );
};
